module.exports = __webpack_public_path__ + "static/media/largeDeliveryTruck_purple.11bda1ea.svg";